export const POINT_SIZE = 8
export const DEFAULT_SIZE = 40
export const DEFAULT_MARGIN_TOP = 0
